import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';
import { handleResponseError } from '../../../utils/helpers/network-error';

export const create = createAsyncThunk('users.create', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { newUser, message }} = await api.users.create(formData);
    onSuccess(message);
    return newUser;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const updateUser = createAsyncThunk('users.update', async ({
  formData, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { _id, ...rest } = formData;

    const formDataWithoutEmptyFields = Object.keys(rest).reduce((acc, key) => {
      if (rest[key]) {
        acc[key] = rest[key];
      }
      return acc;
    }, {});

    const { data: { updatedUser, message }} = await api.users.update(_id, formDataWithoutEmptyFields);
    onSuccess(message);
    return updatedUser;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const getUsers = createAsyncThunk('users.getUsers', async ({
  page, limit, search
}, { rejectWithValue }) => {
  try {
    const queryParams = {
      page,
      limit,
    };

    if (search && search.trim().length > 0) {
      queryParams.search = search.trim();
    }

    const { data: { users, totalDocs }} = await api.users.getUsers(queryParams);
    
    return {
      users,
      totalDocs,
    };
  } catch (error) {
    handleResponseError(error);
    return rejectWithValue();
  }
});

export const deleteUsers = createAsyncThunk('users.deleteUsers', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.users.deleteUsers(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const disableUsers = createAsyncThunk('users.disableUsers', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.users.disableUsers(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});

export const enableUsers = createAsyncThunk('users.enableUsers', async ({
  ids, onSuccess, onFailure
}, { rejectWithValue }) => {
  try {
    const { data: { message }} = await api.users.enableUsers(ids);
    onSuccess(message);
    return ids;
  } catch (error) {
    handleResponseError(error, onFailure);
    return rejectWithValue();
  }
});
